import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { User } from '../types/api.types'

interface CreateUserPayload {
  name: string
  email?: string
  phone?: string
  role: 'SUPER_ADMIN' | 'MANAGER' | 'STAFF'
  password: string
  property_ids?: number[]
}

interface UpdateUserPayload {
  name?: string
  email?: string
  phone?: string
  role?: string
  password?: string
  property_ids?: number[]
}

export const platformUsersService = {
  async getByOrg(orgId: number): Promise<User[]> {
    const { data } = await axiosInstance.get<User[]>(API_ENDPOINTS.PLATFORM_ORG_USERS(orgId))
    return data
  },

  async create(orgId: number, payload: CreateUserPayload): Promise<User> {
    const { data } = await axiosInstance.post<User>(
      API_ENDPOINTS.PLATFORM_ORG_USERS(orgId),
      payload,
    )
    return data
  },

  async update(orgId: number, userId: number, payload: UpdateUserPayload): Promise<User> {
    const { data } = await axiosInstance.put<User>(
      API_ENDPOINTS.PLATFORM_ORG_USER(orgId, userId),
      payload,
    )
    return data
  },

  async setStatus(orgId: number, userId: number, isActive: boolean): Promise<User> {
    const { data } = await axiosInstance.patch<User>(
      API_ENDPOINTS.PLATFORM_ORG_USER_STATUS(orgId, userId),
      { is_active: isActive },
    )
    return data
  },

  async delete(orgId: number, userId: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PLATFORM_ORG_USER(orgId, userId))
  },
}
